import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { Upload, Modal } from 'hljd'
import Store from './store'
import styles from './style.module.less'
import VideoClip from './videoClip'
const { Dragger } = Upload
/**
 * @description:类似小红书视频上传组件，基于hljd组件实现
 * @param {*}
 * @return {*}
 */
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.initChange(this.props)
  }
  componentDidUpdate(prevProps) {
    // 初始化值回填
    if (!prevProps.value && this.props.value) {
      this.store.initValue(this.props)
    }
  }

  render() {
    const {
      video,
      coverPath,
      showClip,
      showUpload,
      isFail,
      failMsgg,
      beforeUpload,
      onVideoChange,
      onVideoDelete,
      onClipShow,
      onClipCancle,
      onClipOk,
      onCoverChange,
      handleVideoLoadError
    } = this.store
    return (
      <Fragment>
        <div>
          {/* 视频上传组件，在没有视频的情况下展示 */}
          {!video && (
            <div className={styles.videoUpload}>
              <Dragger
                onChange={val => onVideoChange(val)}
                beforeUpload={val => beforeUpload(val)}
                isVideoUrl={val => beforeUpload(val)}
                listMode={false}
                accept="video/*"
                width={320}
                height={180}
                upText="建议视频比例为16:9，大小不超过500M 时长不超过5分钟"
              >
                {!isFail && (
                  <div className={styles.video}>
                    <div>
                      <div className={styles.img} />
                      <div className={styles.title}>拖拽或点击上传视频</div>
                      <div className={styles.text}>
                        建议视频比例为16:9，大小不超过500M 时长不超过5分钟
                      </div>
                    </div>
                  </div>
                )}
                {isFail && (
                  <div className={styles.fail}>
                    <div>
                      <div className={styles.img} />
                      <div className={styles.title}>上传失败</div>
                      <div className={styles.text}>{failMsgg}</div>
                    </div>
                  </div>
                )}
              </Dragger>
            </div>
          )}
          {/* 视频展示组件，upload完成后展示 */}
          {video && (
            <>
              <div className={styles.wrapper}>
                <video
                  id="show-video"
                  className={styles.video}
                  controls
                  src={video}
                  onError={e => handleVideoLoadError(e)}
                />
                <div className={styles.delete} onClick={onVideoDelete} />
              </div>
            </>
          )}
          {/* 视频封面截取,视频上传或者初始化后展示 */}
          {video && (
            <div className={styles.imgWrapper}>
              <div className={styles.title}>视频封面</div>
              <img className={styles.img} src={coverPath} />
              <div className={styles.clip} onClick={onClipShow}>
                <div className={styles.icon} />
                <div className={styles.text}>从视频中截取封面</div>
              </div>
              <div className={styles.coverUpload}>
                {/* 这个方法是为了处理上传的时候保持上传组件区域始终为空，看是否可以优化 */}
                {showUpload && (
                  <Dragger
                    width={120}
                    height={90}
                    listMode={false}
                    value={null}
                    clipable
                    aspect={16 / 9}
                    accept="image/*"
                    onChange={val => onCoverChange(val)}
                    cropModalNode={{
                      title: '裁剪封面',
                      content: <div>封面比例为16：9，拉动边框可裁剪封面</div>
                    }}
                  >
                    <div className={styles.upload}>
                      <div className={styles.icon} />
                      <div className={styles.text}>拖拽或点击 上传封面</div>
                    </div>
                  </Dragger>
                )}

                {!showUpload && (
                  <Dragger
                    width={120}
                    height={90}
                    listMode={false}
                    clipable
                    aspect={16 / 9}
                    accept="image/*"
                    onChange={val => onCoverChange(val)}
                    cropModalNode={{
                      title: '裁剪封面',
                      content: <div>封面比例为16：9，拉动边框可裁剪封面</div>
                    }}
                  >
                    <div className={styles.upload}>
                      <div className={styles.icon} />
                      <div className={styles.text}>拖拽或点击 上传封面</div>
                    </div>
                  </Dragger>
                )}
              </div>
            </div>
          )}
          {/* 新增预览图模块 */}
          {/* {video && (
            <div className={styles.preview}>
              <div className={styles.title}>方形封面预览</div>
              <img className={styles.img} src={coverPath} />
              <div className={styles.text}>主要用于商家列表中作品的展示</div>
            </div>
          )} */}
        </div>
        <Modal
          width={600}
          visible={showClip}
          onCancel={onClipCancle}
          onOk={onClipOk}
          title="编辑视频封面"
        >
          <VideoClip store={this.store} />
        </Modal>
      </Fragment>
    )
  }
}
